// src/components/modals/AproveTaskModal.tsx
import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Label,
  Row
} from "reactstrap";

interface AproveTaskModalProps {
  isOpen: boolean;
  toggle: () => void;
  priority: string;
  setPriority: (value: string) => void;
  onConfirm: () => void;
}

const AproveTaskModal: React.FC<AproveTaskModalProps> = ({
  isOpen,
  toggle,
  priority,
  setPriority,
  onConfirm
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} className={`${localStorage.getItem("mode") ? localStorage.getItem("mode") : "light"}`}>
      <ModalHeader className="modal-header-style theme-text-color">Aprovar Tarefa</ModalHeader>
      <ModalBody className="modal-body-style">
        <b style={{ color: "red" }}>
          Ao aprovar a tarefa você confirma que realizou testes o suficiente
          que comprovam o problema no sistema!
        </b>
        <Row className="mt-3 p-2">
          <Label for="task-priority">Prioridade</Label>
          <Input
            id="task-priority"
            type="select"
            value={priority}
            onChange={(e) => setPriority(e.target.value)}
            className="input-modal theme-text-color"
          >
            <option value="-1">Selecione</option>
            <option value="veryHigh">Altíssima</option>
            <option value="high">Alta</option>
            <option value="medium">Média</option>
            <option value="low">Baixa</option>
            <option value="veryLow">Muito Baixa</option>
          </Input>
        </Row>
      </ModalBody>
      <ModalFooter className="modal-footer-style">
        <Button color="primary" onClick={onConfirm} id="btn-aprove-task">
          Aprovar
        </Button>
        <Button color="secondary" onClick={toggle}>
          Cancelar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AproveTaskModal;
